<template>
  <div>
    <button
      class="btn btn--secondary btn--hide-device"
      :class="props.btnClass"
    >
      <NuxtLink :to="props.link" :target="target">{{ props.label }}</NuxtLink>
    </button>
    <button
      class="btn btn--secondary btn--hide-desktop"
      :class="props.btnClass"
    >
      <NuxtLink :to="props.link" :target="target">{{ props.labelMobile || props.label }}</NuxtLink>
    </button>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  link: {type: String, required: true},
  label: {type: String, required: true},
  labelMobile: {type: String, required: false},
  target: {type: String, required: false},
  btnClass: {type: String, required: false},
})

const target = computed(() => {
  return props.target ? props.target : '_self'
})
</script>